import httpClient from '../utils/httpClient';

export function registerEnterprise(data, accessCode) {
  return httpClient.post(
    '/api/org/register-enterprise',
    { ...data, access_code: accessCode },
    { skipAuthRefresh: true } // don't try refresh on 401 from the gate
  );
}

// Invite a member (employee or manager)
export function inviteMember({ email, organizationId }) {
  return httpClient.post('/api/org/invite', { email, organizationId });
}

// Accept an invite
// src/api/organizationApi.js
export function acceptInvite({ token, password, firstName, lastName }) {
  return httpClient.post(
    '/api/org/accept-invite',          // keep your route if that’s what you wired
    { token, password, firstName, lastName },
    { withCredentials: true }
  );
}

// Get org members
// api/organizationApi.js
export function getOrganizationMembers(orgId, options = {}) {
  const params = {};
  if (options.page) params.page = options.page;
  if (options.pageSize) params.pageSize = options.pageSize;

  return httpClient
    .get(`/api/org/${orgId}/members`, { params })
    .then(r => r.data);
}

export async function getOrgSummary(orgId) {
  const { data } = await httpClient.get(`/api/org/${orgId}/summary`);
  return data;
}

// Get all invites for an org
export function getOrgInvites(orgId) {
  return httpClient.get(`/api/org/${orgId}/invites`);
}

//Get managers current organization:
export function getManagerOrganizations() {
    return httpClient.get(`/api/org/`);
  }
  export const assertAdmin = (orgId) =>
  httpClient.get(`/api/org/${orgId}/authorize-admin`);


  export function removeOrgMember({ organizationId, userId }) {
    return httpClient.delete(`/api/org/${organizationId}/members/${userId}`);
  }

export async function updateOrganizationMemberRole(orgId, userId, role) {
  const r = await httpClient.patch(`/api/org/${orgId}/members/${userId}`, { role });
  return r.data;
}
  // src/api/organizationApi.js
export async function getOrgOverview(orgId) {
  const r = await httpClient.get(`/api/org/${orgId}/overview`);
  return r.data;
}

export async function getOrgTrainingByMember(orgId) {
  const { data } = await httpClient.get(`/api/org/${orgId}/training/members`);
  return data;
}

export async function getOrgTrainingPlansSummary(orgId) {
  const { data } = await httpClient.get(`/api/org/${orgId}/training/summary`);
  return data;
}

